// src/components/ErrorQr.js
import React, { useState } from 'react';
import { Box, Typography, Button, Paper } from '@mui/material';
import { Cancel as CancelIcon } from '@mui/icons-material';
import { useNavigate, useLocation } from 'react-router-dom';

import qrErrorIcon from '../assets/images/qr_error_icon.png';
import AsignarUbicacionPaciente from './AsignarUbicacionPaciente';

const ErrorQr = () => {
    const navigate = useNavigate();
    const location = useLocation();
    
    // AÑADIDO: Estado para el modal
    const [openAsignar, setOpenAsignar] = useState(false);

    const errorMessage = location.state?.message || 'Ocurrió un error inesperado durante el escaneo del código QR.';

    const handleGoToClients = () => {
        navigate('/clientes');
    };

    return (
        <Box sx={{ p: 3, pt: 8, display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', bgcolor: '#f5f5f5' }}>
            <Paper elevation={3} sx={{ p: 5, textAlign: 'center', maxWidth: 450, borderRadius: 2 }}>
                
                <Box sx={{ mb: 3 }}>
                    <img 
                        src={qrErrorIcon}
                        alt="Error de lectura de QR" 
                        style={{ width: '250px', height: '250px', objectFit: 'contain' }}
                    />
                </Box>
                
                <Typography variant="h5" color="error" gutterBottom>
                    QR No Encontrado
                </Typography>
                
                <Typography variant="body1" color="textSecondary" sx={{ mb: 4 }}>
                    {errorMessage}
                </Typography>
                
                <Button 
                    variant="contained" 
                    color="primary" 
                    onClick={handleGoToClients}
                    sx={{ mt: 2, mr: 1 }}
                >
                    Volver a Clientes
                </Button>

                {/* Botón para abrir el asignador */}
                <Button 
                    variant="outlined" 
                    color="secondary" 
                    onClick={() => setOpenAsignar(true)}
                    sx={{ mt: 2 }}
                >
                    Asignar Ubicación
                </Button>

                {/* Modal de asignación */}
                <AsignarUbicacionPaciente 
                    open={openAsignar} 
                    handleClose={() => setOpenAsignar(false)} 
                />

            </Paper>
        </Box>
    );
};

export default ErrorQr;